import { render } from "./MedicalView.vue?vue&type=template&id=2106274e&scoped=true&ts=true"
import script from "./MedicalView.vue?vue&type=script&lang=ts"
export * from "./MedicalView.vue?vue&type=script&lang=ts"

import "./MedicalView.vue?vue&type=style&index=0&id=2106274e&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\newbdb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2106274e"]])

export default __exports__